import { useMutation } from "@shared/lib/hooks";
import { PricingWorkloadService } from "../services/PricingWorkload.service";

export default function useEditPricingNotes(handleSuccess?: () => void) {
  const { mutate, isLoading, isSuccess, error } = useMutation({
    mutationFn: (payload: { briefInfluencerId: string; notes: string }) =>
      PricingWorkloadService.editPricingNotes(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: () => {
      handleSuccess?.();
    },
  });
  return {
    editPricingNotes: mutate,
    isEditPricingNotesLoading: isLoading,
    isEditPricingNotesSuccess: isSuccess,
    editPricingNotesError: error,
  };
}
